import * as React from 'react';
import {
  Breadcrumbs,
  BreadcrumbLink,
} from '@spaced-out/ui-design-system/lib/components/Breadcrumbs';
import css from './custom-breadcrumbs.css';


type BreadcrumbItem = {
  name: string;
  isActive: boolean;
  onClick: (arg1: unknown) => void;
  color?: 'primary' | 'secondary';
};

type CustomBreadCrumbsProps = {
  breadCrumbLinks: Array<BreadcrumbItem>;
};

export const CustomBreadCrumbs = ({
  breadCrumbLinks = [],
}: CustomBreadCrumbsProps) => (
  <Breadcrumbs
    classNames={{
      wrapper: css.container,
    }}
  >
    {breadCrumbLinks.map(({name, isActive, onClick, color = 'primary'}) => (
      <BreadcrumbLink
        id={name}
        key={name}
        onClick={onClick}
        isActive={isActive}
      >
        {name}
      </BreadcrumbLink>
    ))}
  </Breadcrumbs>
);
